import { CIMSModule, CIMSPage, Permission } from 'shared'
import { useProtectedMenuItem } from './useProtectedMenuItem'

export function useEJ() {
  return useProtectedMenuItem({
    module: CIMSModule.EJ,
    pages: [
      {
        page: CIMSPage.EJLog,
        permission: Permission.ViewEngineeringJudgement,
      },
      {
        page: CIMSPage.EJTypes,
        permission: Permission.ViewEJType,
      },
      {
        page: CIMSPage.EJQuickLinks,
        permission: Permission.ViewEJQuickLink,
      },
      {
        page: CIMSPage.EJNotifications,
        permission: Permission.ViewEJNotification,
      },
    ],
  })
}
